var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgConnections = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M3.309 8.75a4.75 4.75 0 0 0 8.05 2.615.75.75 0 1 0-1.06-1.06 3.25 3.25 0 0 1-2.21.95A.77.77 0 0 0 8 11.25a3.25 3.25 0 0 1-3.25-3.246 3.25 3.25 0 0 1 5.548-2.296.75.75 0 0 0 1.06-1.06 4.75 4.75 0 0 0-3.25-1.39A.757.757 0 0 0 8 3.25a4.75 4.75 0 0 0-4.69 4H2a.75.75 0 0 0 0 1.5h1.309z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M14 8.75a.75.75 0 0 0 0-1.5H9.855a2 2 0 1 0 0 1.5H14z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgConnections);
export default ForwardRef;